import React from "react";

export default function LangToggle({ lang, setLang }) {
  const toggle = () => setLang(lang === "en" ? "fr" : "en");

  return (
    <button
      onClick={toggle}
      className="
        relative flex items-center justify-between
        w-[68px] h-8
        bg-gray-100 border border-gray-400
        transition-all duration-300 ease-in-out
        focus:outline-none focus:ring-1 focus:ring-gray-400
      "
    >
      <span
        className={`text-[11px] font-bold tracking-wide ml-1 ${
          lang === "en" ? "text-gray-900" : "text-gray-500"
        }`}
      >
        EN
      </span>
      <span
        className={`text-[11px] font-bold tracking-wide mr-1 ${
          lang === "fr" ? "text-gray-900" : "text-gray-500"
        }`}
      >
        FR
      </span>

      {/* moving black square */}
      <span
        className={`
          absolute top-[1.5px] left-[1.5px] w-[31px] h-[29px] bg-black
          transform transition-transform duration-300 ease-in-out
          ${lang === "fr" ? "translate-x-[33px]" : ""}
        `}
      />
    </button>
  );
}
